export default "__VITE_ASSET__CUe4ylwJ__"